import { atom } from "jotai";

export const newAnnotationAtom = atom<VirtualTourAnnotation | null>(null);
